import React from "react"
import styled from "styled-components"
import { Link } from "react-router-dom"
import Text from "../../../_components/Text"
import * as colors from "../../../assets/_base/colors"
import MaskedInput from "react-input-mask"
import LoadingInput from "../../../_components/LoadingInput"
import WhatsAppButton from "../../AppViews/Footer/WhatsAppButton"
import axios from "axios"
import { baseURL } from "../../../api"
import { setCookieByName, showSnackBar } from "../../../utils"
import { login } from "../../../api/auth"
import { getUser } from "../../../api/users"

const LogoImage = styled.img`
    max-width: 150px;
`
const Container = styled.div`
    min-height: 100vh;
    background-color: ${colors.light};
`
const UseTerms = styled.div`
    display: flex;
    justify-content: baseline;
    alig-items: baseline;

    input {
        cursor: pointer;
    }

    label {
        margin-left: 10px;
    }
`
const BigButtonRegister = styled.button`
    margin-top: 20px;
    border: none;
    background-color: ${colors.lightBlue};
    box-sizing: border-box;
    min-width: 350px;
    max-width: 350px;

    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 30px;
    border-bottom: 6px solid ${colors.darkBlue};
    transition: all .3s;

    p {
        margin: 0px;
        padding: 0px;
        font-size: 20px;
        font-weight: bold;
        color: white;
    }

    :active{
        border-bottom: 2px solid ${colors.lightBlue};
        padding-top: 10px;
        padding-bottom: 10px;
    }
    :disabled{
        cursor: not-allowed;
        background-color: ${colors.lightCyan};
        padding-top: 10px;
        padding-bottom: 10px;
        border-bottom: 0px solid ${colors.lightBlue};
    }

`
const BackButton = styled(Link)`
    margin-top: 20px;
    border: none;
    background-color: ${colors.lightBlue};
    box-sizing: border-box;
    min-width: 300px;
    max-width: 300px;

    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 30px;
    border-bottom: 6px solid ${colors.darkBlue};
    transition: all .3s;

    p {
        margin: 0px;
        padding: 0px;
        font-size: 15px;
        font-weight: bold;
        color: white;
        text-align: center;
    }

    :active{
        border-bottom: 2px solid ${colors.darkBlue};
        padding-top: 10px;
        padding-bottom: 10px;
    }
`

export default props => {
    const [data, setData] = React.useState({
        timezone: "America/Belem",
        access_type: 1
    })
    function getPlatform() {
        let userPlatform = navigator.userAgent;
        let platforms = {
            "Android": "Android",
            "android": "android",
            "iPhone": "iPhone",
            "Windows": "Windows",
            "Mac": "Mac",
            "Linux": "Linux",
        };

        for (let key in platforms) {
            if (userPlatform.includes(key)) {
                return platforms[key];
            }
        }
        return;
    }

    function getURLParameters() {
        var params = {
            create_rd_lead: true,
            referrer: document.referrer,
            platform: getPlatform()
        };
        var queryString = location.search.split('?')[1];

        if (queryString) {
            var keyValuePairs = queryString.split('&');

            keyValuePairs.forEach(function (keyValuePair) {
                var key = keyValuePair.split('=')[0];
                var value = keyValuePair.split('=')[1];
                params[key] = value
            });
            params.referrer = decodeURIComponent(params.referrer);
        }

        return params;
    }
    const [loading, setLoading] = React.useState(false)

    function onChange(e) {
        let { name: key, value } = e.target
        if (key === "accepted") {
            value = !data.accepted
        }
        setData({
            ...data,
            [key]: value
        })
    }

    function onSubmit(e) {
        e.preventDefault()
        data.phone = data.phone.replace(/\D+/g, '')
        if (data.phone.length < 9) {
            showSnackBar("O telefone é inválido")
            try { document.querySelector('[name="phone"]').focus() } catch (error) { }
            return
        }
        if (data.password.length < 5) {
            showSnackBar("informe uma senha mais longa!")
            try { document.querySelector('[name="password"]').focus() } catch (error) { }
            return
        }
        const params = getURLParameters()
        setLoading(true)
        axios.post(`${baseURL}users/`, data, { params })
            .then(resp => {
                login(data)
                    .then(resp => {
                        setCookieByName("access", resp.data.access)
                        setCookieByName("refresh", resp.data.refresh)
                        window.localStorage.setItem("easygestorweb_apikey", resp.data.access)
                        window.localStorage.setItem("easygestorweb_refresh_token", resp.data.refresh)
                        getUser()
                            .then(user => {
                                setCookieByName("username", user.name)
                                window.localStorage.setItem("easygestorweb_userdata", JSON.stringify(user))
                                setCookieByName("role", user.access_type)
                                if (user.salesperson) {
                                    let branch = user.salesperson.branch_owner

                                    if (branch.company) {
                                        branch.name = branch.company.fancy_name
                                    }
                                    setCookieByName("branch_owner_name", branch.name)
                                    setCookieByName("branch_owner_id", branch.id)
                                    setCookieByName("branch_state_name", branch.address.state)
                                    window.localStorage.setItem("easygestorweb_current_branch", JSON.stringify(branch))
                                }
                                window.location.href = "/branches/create"
                            })
                    })
            })
            .catch(error => {
                if (error.response) {
                    const { data } = error.response
                    if (data.email) {
                        showSnackBar("Este email já está cadastrado")
                    }
                } else {
                    showSnackBar("Verifique os dados e tente novamente!")
                }
            })
            .finally(error => {
                setLoading(false)
            })

    }
    return <Container className="container-fluid py-4">
        <div className="row">
            <div className="col-12 text-center">
                <LogoImage className="" src='https://content.easygestor.com/easygestor/logo_easygestor.png' alt="Easygestor web logo image" />

                <Text as="h1" className="py-3">
                    Bem-vindo(a) ao Easygestor Web!
                </Text>
                <Text>
                    Preencha os campos abaixo
                </Text>
            </div>
        </div>
        <form action="/" method="get" onSubmit={onSubmit}>
            <div className="row">
                <div className="col-md-4 mx-auto">
                    <div className="form-group">
                        <div className="form-label">
                            <Text className="m-0 ">
                                Nome completo *
                            </Text>


                            <LoadingInput
                                loading={loading}
                                required
                                nogroup
                                onChange={onChange}
                                name="name"
                                maxLength={40}
                                placeholder="Informe seu nome completo" />
                            <div className='px-3 row d-flex justify-content-between' >
                                <span>máx. 40 caracteres.</span>
                                <span className='justify-content-end'>{data.name ? data.name.length : 0}/40</span>
                            </div>
                        </div>

                    </div>
                    <div className="form-group">
                        <div className="form-label">
                            <Text className="m-0 mb-2">
                                Telefone *
                            </Text>
                            <MaskedInput
                                required
                                disabled={loading}
                                onChange={onChange}
                                name="phone"
                                type="tel"
                                mask="(99) 99999-9999"
                                className="form-control"
                                placeholder="Informe seu telefone" />
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="form-label">
                            <Text className="m-0 mb-2">
                                Email *
                            </Text>
                            <LoadingInput
                                required
                                loading={loading}
                                type="email"
                                name="email"
                                onChange={onChange}
                                maxLength={100}
                                placeholder="Informe o seu email" />
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="form-label">
                            <Text className="m-0 mb-2">
                                Senha *
                            </Text>
                            <LoadingInput
                                required
                                loading={loading}
                                type="password"
                                name="password"
                                onChange={onChange}
                                maxLength={100}
                                placeholder="Defina sua senha de acesso" />
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="form-label">
                            <Text className="m-0 mb-2">
                                Confirme sua senha *
                            </Text>
                            <LoadingInput
                                required
                                loading={loading}
                                type="password"
                                name="password2"
                                onChange={onChange}
                                maxLength={100}
                                placeholder="Defina confirme sua senha de acesso" />
                            <span className="text-danger p-0 m-0">
                                {
                                    data.password !== data.password2
                                        ? "Senhas diferentes"
                                        : ""
                                }
                            </span>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="form-label">
                            <Text className="m-0 mb-2">
                                Termos de uso *
                            </Text>
                            <UseTerms>
                                <input
                                    disabled={loading}
                                    checked={data.accepted}
                                    name="accepted"
                                    onChange={onChange}
                                    className="form-control"
                                    type="checkbox" />
                                <label>
                                    Declaro que li e concordo com os <a target="blank" href="https://easygestor.com/sem-categoria/2020/01/20/termos-termos-de-uso-do-sistema-easygestor-online.easyml">termos de uso</a>
                                </label>
                            </UseTerms>
                        </div>
                    </div>
                </div>
                <div className="col-12 d-flex justify-content-center">
                    <BigButtonRegister
                        disabled={!data.accepted || loading || (data.password !== data.password2)}>
                        <Text>
                            Criar Conta
                        </Text>
                    </BigButtonRegister>
                </div>
                <div className="col-12 d-flex justify-content-center p-3">
                    <Text className="p-0 m-0">
                        Você já possui sua conta Easygestor?
                    </Text>
                </div>
                <div className="col-12 d-flex justify-content-center">
                    <BackButton
                        to="/" >
                        <Text>
                            Fazer seu login
                        </Text>
                    </BackButton>
                </div>
            </div>
        </form>
        <WhatsAppButton />
    </Container>
}


// WEBPACK FOOTER //
// ./src/views/Auth/Register/index.jsx